// 排行榜接口
import { get, post } from '~/assets/js/api/methods'
// import { cloudbrokers } from '~/utils/cacheparams/index.js'
import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList

export default (axios) => ({
  ranking: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/ranking/init-v1`, params), // 获取排行榜列表
  rankinghomeClient: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/ranking/init-v1`, params), // 获取排行榜列表---客户端
  dcRanking: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/ranking/dc/init-v1`, params), // 获取点差排行榜列表(服务端)
  dcRankingClient: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/ranking/dc/init-v1`, params), // 获取点差排行榜列表(客户端)
  // cloudbrokers: (params = {}, contry, lang) => get(axios, 'https://rating.zy223.com/eahost/ext/cloudbrokers.json', params, cloudbrokers) // vpscode
  cloudbrokers: (params = {}) => post(axios, `${testwikidatacenter}/wikifxweb-v1/invoke-v3/vpstraderlist`, params)
})
